export default __webpack_public_path__ + "ff2bc3a33d2bd2a8ec0c55c178389eb8.webp";